module.exports = __webpack_public_path__ + "static/media/bg2_lighten.cb7fc0fd.png";